module.exports = __webpack_public_path__ + "img/212w.0b3a97d.jpg";